import React, { useEffect } from 'react'
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";


// components
import ApplicativeList from "./_list";
import ApplicativeForm from "./_form";
import { showLoader } from "../../../components/loader/loader";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { clearState, setApp, setCategory, setLoading, setUdn, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const Applicative = props => {
    const { loading } = props.mainProps


    // limpia el state
    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);


    const createItem = () => {
        props.setForm()
        ModalFormContainer(ApplicativeForm, {data : null, Form: ApplicativeForm})
    }


    return <>
        { loading && showLoader() }

        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={createItem} />
                    </div>
                </div>
            </Col>
            <Col>
                <ApplicativeList />
            </Col>
        </Row>
    </>
}


const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading
});

export default connect(mapStateToProps, mapActionsToProps)(Applicative)